import { useLayoutEffect, useEffect } from "react";
import { isBrowser } from "@fwa/src/utils/browserUtils";

// The sole purpose of this hook is to silence pointless warnings in next.js when using
// useLayoutEffect about it not being isomorphic which is the whole point of the hook
// which waits for components to be mounted to the DOM for scroll handlers etc.
export const useLayoutEffectBrowser = isBrowser ? useLayoutEffect : useEffect;

export default useLayoutEffectBrowser;
